export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/shawna-profile-4f826bed8e83703d1be9888e52e97201.png";